// components/AvatarUpload/index.js - Versão ajustada
import React, { useContext, useState } from 'react';
import { i18n } from "../../translate/i18n";
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import Box from '@mui/material/Box';
import { AuthContext } from '../../context/Auth/AuthContext';
import { getBackendUrl } from '../../config';
import defaultAvatar from '../../assets/avatar.svg';

const backendUrl = getBackendUrl();


const AvatarUploader = ({ setAvatar, avatar, companyId }) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
  const { user } = useContext(AuthContext);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    
    if (!file) return;

    // Validar tipo de arquivo
    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp'];
    if (!allowedTypes.includes(file.type)) {
      alert(i18n.t("avatarUpload.errors.unsupportedFormat"));
      return;
    }

    // Validar tamanho (máximo 5MB)
    const maxSize = 5 * 1024 * 1024; // 5MB
    if (file.size > maxSize) {
      alert("¡Archivo muy grande! Máximo 5MB");
      return;
    }

    setSelectedFile(file);
    setAvatar(file);

    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setPreviewImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  // Função para determinar qual imagem exibir
  const getImageSrc = () => {
    if (previewImage) return previewImage;
    if (avatar && companyId) return `${backendUrl}/public/company${companyId}/user/${avatar}`;
    // FASE4-PASO8 (ronda de seguridad de /public, bug real
    // encontrado): /public/app/noimage.png nunca existio en el
    // servidor -- public/app/ no existe. Usa el avatar generico que
    // ya viaja empaquetado con el frontend, cero dependencia del
    // backend.
    return defaultAvatar;
  };

  return (
    <Box display="flex" flexDirection="column" alignItems="center">
      {/* Ver TAREA: reorganización SectionCard (mockup
          https://claude.ai/artifact/M3q9ar6VJft7zQ39HCyZBL) -- 120px->76px
          y botón restyleado a pill chico. Único consumidor confirmado
          (UserModal), por eso se ajusta directo acá en vez de agregar
          props de tamaño con default retrocompatible -- cero cambio de
          lógica (mismo handleFileChange/setAvatar de siempre). */}
      <Avatar
        alt="User Avatar"
        src={getImageSrc()}
        style={{ width: 76, height: 76, cursor: 'pointer' }}
        onClick={() => document.getElementById('avatar-upload').click()}
        onError={(e) => {
          // Fallback para imagem padrão em caso de erro
          e.target.src = defaultAvatar;
        }}
      />

      <input
        accept="image/*"
        type="file"
        id="avatar-upload"
        style={{ display: 'none' }}
        onChange={handleFileChange}
      />
      <label htmlFor="avatar-upload" style={{ marginTop: 10 }}>
        <Button
          variant="contained"
          component="span"
          size="small"
          startIcon={<CloudUploadIcon sx={{ fontSize: 14 }} />}
          sx={{ fontSize: 11.5, fontWeight: 700, borderRadius: "8px", textTransform: "none", boxShadow: "none", background: "#0399FF", "&:hover": { background: "#0284d4", boxShadow: "none" } }}
        >
          {avatar ? 'Cambiar Avatar' : 'Subir Avatar'}
        </Button>
      </label>
    </Box>
  );
};

export default AvatarUploader;